<template>
    <div class="input-group" :class="{'has-color':$props.type == 'color'}">

        <label v-if="label" class="text-white padding-sm-bottom padding-sm-top">
            <small>{{label}}</small>
        </label>
        <div class="input-field">
            <input :type="type" :class="[classes,{'has-icon':$slots.image},customClasses]"
            ref="input"
            :value="value"
            :placeholder="placeholder" v-on="listeners" :disabled="$props.disabled"
            :minlength="minlength"
            :enterkeyhint="enterkeyhint"
            :maxlength="maxlength"/>

            <figure class="padding-sm-right" v-if="$slots.image" :class="[customClasses, {'figure-rounded': rounded, 'figure-large': large}]">
                <slot name="image" ></slot>
            </figure>
        </div>
    </div>
</template>

<script>
export default {
    name:'inputfield',
    props:{
        label:String,
        minlength:Number,
        maxlength:Number,
        value:{
            type:[String,Number],
            default:''
        },
        placeholder:{
            type:String,
        },
        type:{
            type:String,
            default:'text'
        },
        enterkeyhint: String,
        large: Boolean,
        small: Boolean,
        disabled: Boolean,
        rounded: Boolean,
        customClasses:{
            type:Array,
            default: () => ['bg-mid-black','text-white']
        },
        focusOnMounted: {type: Boolean, required: false, default: false}
    },
    computed:{
        classes(){
            return [
                {'input-sm':this.small},
                {'input-lg':this.large},
                {'input-rounded':this.rounded}
            ]
        },
        listeners(){
            return {
                ...this.$listeners,
                input: this.updateValue,
                focus: this.onFocus,
                blur: this.onBlur
            }
        }
    },
    methods:{
        updateValue(evt){
            let value = evt.target.value;
            this.$emit('input',value);
        },
        onFocus(value){
            this.$emit('focus',value);
        },
        onBlur(value){
            this.$emit('blur',value);
        }
    },
    mounted() {
      if(this.focusOnMounted) {
        this.$refs.input.focus()
      }
    }
}
</script>

<style lang="scss" scoped>
@import './inputfield.scss';
</style>
